module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modalcon"
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "closebtn",
    on: {
      "click": function($event) {
        _vm.setPopup(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "mbox"
  }, [_c('div', {
    staticClass: "modal-body mb0"
  }, [_c('div', {
    staticClass: "justify-content-center align-content-center"
  }, [_c('div', [_c('div', [_c('h2', {
    staticClass: "app-cashback-header"
  }, [_vm._v("\n                      " + _vm._s(_vm.title) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "popuplist"
  }, _vm._l((_vm.txtArr), function(txt, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n                     " + _vm._s(index + 1) + ". " + _vm._s(txt) + "\n                    ")])
  }))])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67bfb211"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/commonMsgPopUp.vue
// module id = 925
// module chunks = 117